// 子仓库 - 渠道管理
import to from 'await-to-js';
import * as apis from "@/api/interface/qdgl";

export default {
  namespaced: true,
  state: () => ({
    zzdStatsList: undefined, //赠转短链路数据 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 母渠道管理 - 母渠道code选项
    async getChannelCodeOptions(_, payload = {}) {
      const [, res] = await to (apis.getChannelCodeOptions(payload));
      return res;
    },
    // 母渠道管理 - 子渠道code选项
    async getSubChannelCodeOptions(_, payload = {}) {
      const [, res] = await to (apis.getSubChannelCodeOptions(payload));
      return res;
    },



    // 赠转短链路数据 - 列表
    async getZzdStatsList(ctx, payload = {}) {
      const [err, res] = await to (apis.getZzdStatsList(payload));
      ctx.commit("update", {
        zzdStatsList: !err && res.data ? res.data : undefined,
      });
    },
    // 赠转短链路数据 - 子渠道code选项
    async getZzdSubChannelCodeOptions(_, payload = {}) {
      const [, res] = await to (apis.getZzdSubChannelCodeOptions(payload));
      return res;
    },
    // 赠转短链路数据 - 失效
    async unValidZzdStats(_, payload = {}) {
      const [, res] = await to (apis.unValidZzdStats(payload));
      return res;
    },

    
    // 获取黑牛客服电话
    async getHnServiceTel(_, payload = {}) {
      const [, res] = await to (apis.getHnServiceTel(payload));
      return res;
    },
  },
  modules: {},
};
